import axios from "axios";
import { emitToasterMsg } from "./toasterUtility";

const axiosHttp = axios.create({
	baseURL: process.env.REACT_APP_BASE_URL,
});
axiosHttp.interceptors.request.use(
	(config) => {
		const wcn = sessionStorage.getItem("wcn");
		config.withCredentials = true;
		config.headers["x-wcn"] = wcn;
		config.headers["Content-Type"] =
			config.headers["Content-Type"] || "application/json";
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

axiosHttp.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		if (error.response && error.response.status === 403) {
			emitToasterMsg(
				"error",
				"Access denied",
				"You do not have permission to perform this action."
			);
		}
		return Promise.reject(error);
	}
);

export default axiosHttp;
